var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 27.964 27.964",
    xmlSpace: "preserve",
    width: "64px",
    height: "64px",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "c126_exclamation"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.982,0.001C6.259,0.001,0,6.259,0,13.984c0,7.721,6.259,13.98,13.982,13.98c7.722,0,13.982-6.26,13.982-13.98 C27.965,6.259,21.704,0.001,13.982,0.001z M13.982,26.533c-6.933,0-12.551-5.619-12.551-12.549 c0-6.935,5.618-12.552,12.551-12.552c6.931,0,12.55,5.617,12.55,12.552C26.532,20.914,20.913,26.533,13.982,26.533z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.004,
    y: 10.551,
    width: 3.931,
    height: 12.649
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.995,5.072c-1.265,0-2.095,0.852-2.095,1.963c0,1.087,0.802,1.964,2.044,1.964c1.317,0,2.119-0.877,2.119-1.964 C16.037,5.924,15.262,5.072,13.995,5.072z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_1_139_"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.305d95a0ef5fded89365edf40a9728be.svg";
export { ForwardRef as ReactComponent };